module.exports = __webpack_public_path__ + "static/hotblack-events4-749d759c7bd6b44d72c6686473df9d16.jpg";